import React from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

interface BasicDetailsProps {
  styles: { [key: string]: string };
}

const BasicDetails: React.FC<BasicDetailsProps> = ({ styles }) => (
  <div className={styles.stepContainer}>
    <h2 className={styles.stepTitle}>Basic Details</h2>
    
    <div className={styles.formGrid}>
      <div className={styles.formColumn}>
        <Form.Item 
          label="Industry" 
          name="industry"
          rules={[{ required: true, message: 'Please select an industry' }]}
          className={styles.formItem}
        >
          <Select placeholder="Select Industry" className={styles.selectInput}>
            <Option value="general">General</Option>
            <Option value="healthcare">Healthcare</Option>
            <Option value="finance">Finance</Option>
            <Option value="ecommerce">E-commerce</Option>
            <Option value="insurance">Insurance</Option>
            <Option value="retail">Retail</Option>
          </Select>
        </Form.Item>

        <Form.Item 
          label="Language" 
          name="language"
          rules={[{ required: true, message: 'Please select a language' }]}
          className={styles.formItem}
        >
          <Select placeholder="Select Language" className={styles.selectInput}>
            <Option value="english-us">English (US)</Option>
            <Option value="english-uk">English (UK)</Option>
          </Select>
        </Form.Item>

        <Form.Item 
          label="Sub Type" 
          name="type"
          rules={[{ required: true, message: 'Please select a sub type' }]}
          className={styles.formItem}
        >
          <Select placeholder="Select Type" className={styles.selectInput}>
            <Option value="service">Service</Option>
            <Option value="product">Product</Option>
            <Option value="tool">Tool</Option>
          </Select>
        </Form.Item>
      </div>

      <div className={styles.formColumn}>
        <Form.Item 
          label="Item Name" 
          name="itemName"
          rules={[{ required: true, message: 'Please enter an item name' }]}
          className={styles.formItem}
        >
          <Input placeholder="Enter Item Name" className={styles.textInput} />
        </Form.Item>

        <Form.Item 
          label="Tags" 
          name="tags"
          className={styles.formItem}
        >
          <Input placeholder="Enter Tags (comma-separated)" className={styles.textInput} />
        </Form.Item>

        <Form.Item 
          label="Description" 
          name="description"
          rules={[{ required: true, message: 'Please enter a description' }]}
          className={styles.formItem}
        >
          <TextArea 
            placeholder="Enter Description" 
            className={styles.textareaInput}
            rows={4}
          />
        </Form.Item>
      </div>
    </div>
  </div>
);

export default BasicDetails;
